export function rmEl(obj) {
    let temp = obj.map(i => JSON.stringify(i))
    let set = new Set(temp)
    let temp2 = [...set]
    return temp2.map(i => JSON.parse(i))
}